<div class="row">
    <div [ngClass]="isCard?'isCard':''" class="col-sm-6" *ngFor="let templateStyle of templateStyles">
        <div class="c-form-group">
            <label [for]="'template' + templateStyle.code" class="c-form-group__label isCard_label">
                <span>{{templateStyle.label}}</span>
            </label>
            <div [id]="'template' + templateStyle.code" title="{{templateStyle.label}}"
                [ngClass]="[templateStyle.code == selectedLayout?templateStyle.code + ' active':templateStyle.code,isCard?'isCard_image':'' ]"
                (cclClick)="changeTemplate(templateStyle.code)"
            ></div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>
